<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-2">
      {{ $t("af:mortgage_preliminary.first_step.title") }}
    </p>

    <p class="has-text-grey-icon">
      {{ $t("af:mortgage_preliminary.first_step.subtitle") }}
    </p>

    <p class="label mt-5">
      {{ $t("af:mortgage_preliminary.first_step.mortgage_purpose.title") }}
    </p>

    <b-select
      v-model="mortgagePurpose"
      expanded
      :placeholder="
        $t('af:mortgage_preliminary.first_step.mortgage_purpose.placeholder')
      "
    >
      <option value="UJ_LAKAS_VASARLASA">Új lakás vásárlása</option>
      <option value="UJ_LAKOHAZ_VASARLASA">Új lakóház vásárlása</option>
      <option value="HASZNALT_LAKAS_VASARLASA">Használt lakás vásárlása</option>
      <option value="HASZNALT_LAKOHAZ_VASARLASA">
        Használt lakóház vásárlása
      </option>
      <option value="LAKASCELU_HITEL_KIVALTASA">
        Lakáscélú hitel első kiváltása
      </option>
    </b-select>

    <AmountSlider :mortgage="true" class="my-5" v-model="amount" />

    <TermSlider :mortgage="true" class="my-5" v-model="duration" />

    <p class="label mt-5">
      {{ $t("af:mortgage_preliminary.first_step.interest_period.title") }}
    </p>

    <b-select
      v-model="interestPeriod"
      expanded
      :placeholder="
        $t('af:mortgage_preliminary.first_step.interest_period.placeholder')
      "
    >
      <!--      <option value="OT_EV">5 évre</option>-->
      <option value="TIZ_EV">10 évre</option>
      <!--      <option value="TIZENOT_EV">15 évre</option>-->
      <option value="VEGIG_FIX">Végig fix</option>
    </b-select>

    <b-switch v-model="greenPurpose" class="mt-5" type="is-info">{{
      $t("af:mortgage_preliminary.first_step.green_goal.title")
    }}</b-switch>

    <div class="offer-change-info mt-5">
      <b-icon
        icon-pack="fa"
        icon="info-circle"
        size="is-medium"
        type="is-blue"
        class="mr-2"
      ></b-icon>
      <span class="has-text-grey-icon">{{
        $t("af:mortgage_preliminary.first_step.footer")
      }}</span>
    </div>
  </div>
</template>

<script>
import { FIELD_MASK } from "@/utils/const";
import merchandiseMixin from "../../mixins/merchandiseMixin";

export default {
  name: "MortgagePreliminaryCoreQuestions",
  mixins: [merchandiseMixin],
  components: {
    AmountSlider: () => import("@/components/AmountSlider.vue"),
    TermSlider: () => import("@/components/TermSlider.vue"),
  },
  props: {
    filterSettings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      amount: 0,
      duration: 0,
      mortgagePurpose: null,
      interestPeriod: null,
      greenPurpose: false,
      downPayment: 0,
      extraAmount: 0,
      FIELD_MASK,
    };
  },
  async created() {
    await this.prefillValue("amount");
    await this.prefillValue("duration");
    await this.prefillValue("mortgagePurpose");
    await this.prefillValue("interestPeriod");
    await this.prefillValue("greenPurpose");

    this.$watch("amount", this.amountWatcher);
    this.$watch("duration", this.durationWatcher);
    this.$watch("mortgagePurpose", this.mortgagePurposeWatcher);
    this.$watch("interestPeriod", this.interestPeriodWatcher);
    this.$watch("greenPurpose", this.greenPurposeWatcher);
  },
  methods: {
    prefillValue(questionId) {
      this[questionId] = this.getAmountFromStore(questionId);
    },
    getAmountFromStore(questionId) {
      return this.$store.getters["mortgagePreliminaryAssessment/answer"](
        questionId
      );
    },
    storeData(questionId) {
      this.$store.dispatch("mortgagePreliminaryAssessment/addData", {
        question: questionId,
        answer: this[questionId],
      });
    },
    amountWatcher() {
      this.storeData("amount");
    },
    durationWatcher() {
      this.storeData("duration");
    },
    mortgagePurposeWatcher() {
      this.storeData("mortgagePurpose");
    },
    interestPeriodWatcher() {
      this.storeData("interestPeriod");
    },
    greenPurposeWatcher() {
      this.storeData("greenPurpose");
    },
  },
};
</script>

<style scoped lang="scss">
.offer-change-info {
  display: flex;
  align-items: center;
}

.mbh {
  .offer-change-info {
    border-radius: 24px;
    padding: 16px 24px 16px 24px;
    background: #e6e9f0;

    .has-text-grey-icon {
      color: #203667 !important;
    }
  }
}

.loan-min-max {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
</style>
